<i18n>
en:
  complete:
    new: "Registration completed.<br>Regards TEBSTA !"
    edit: "Update completed."
  signup:
    label: "Sign up now"
ja:
  complete:
    new: "登録が完了しました。<br>TEBSTAをよろしくお願いします！"
    edit: "更新が完了しました。"
  signup:
    label: "ログインする"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- 新規登録時
      v-row(v-if="newEntry")
        v-col(cols="12" align="center")
          v-alert(dense outlined prominent type="success" border="bottom")
            div(v-html="$t('complete.new')")
        v-col.my-12.py-12(cols="12" align="center")
          strong
            a(href="#" @click="$router.push({name: 'Login'})")|{{$t('signup.label')}}

      //- 編集時
      v-row(v-else)
        v-col.mb-12.pb-12(cols="12" align="center")
          v-alert(dense outlined prominent type="success" border="bottom")
            div(v-html="$t('complete.edit')")
</template>

<script>
export default {
  props: {
    // 新規登録（false: 編集）
    newEntry: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
